import React, { useState } from 'react';

import { createTheme, ThemeProvider } from '@mui/material/styles';

import {
	Box,
	Button,
	Checkbox,
	FormControlLabel,
	Grid,
	Input,
	Typography,
} from '@mui/material';

import RemoveIcon from '@mui/icons-material/Remove';

import MenuIcon from '@mui/icons-material/Menu';

import AddIcon from '@mui/icons-material/Add';

import Paper from '@mui/material/Paper';

import InputBase from '@mui/material/InputBase';

import Divider from '@mui/material/Divider';

import IconButton from '@mui/material/IconButton';

import DirectionsIcon from '@mui/icons-material/Directions';

function MessagesSetting() {
	const defaultTheme = createTheme();

	const [suggestions, setSuggestions] = useState([
		{ label: 'Suggestion #1', value: 'Great Thanks' },
		{ label: 'Suggestion #2', value: 'Awesome!' },
		{ label: 'Suggestion #3', value: 'Good Job' },
		{ label: 'Suggestion #4', value: 'Well done' }
	]);

	// Function to handle changing default value
	const handleChangeDefaultValue = (index, newValue) => {
		setSuggestions((prevSuggestions) => {
			const updatedSuggestions = [...prevSuggestions];
			updatedSuggestions[index].value = newValue;

			return updatedSuggestions;
		});
	};

	return (
		<ThemeProvider theme={defaultTheme}>
			<Grid container xs={12} lg={12} md={12} xl={12}>
				
					<Grid item container lg={4.5} xl={4.5} md={4.5} sm={3.5}>
						<Grid
							item
							xs={12}
							lg={12}
							md={12}
							sm={12}
							xl={12}
							sx={{
								background: '#EEF5FFCC',
								padding: '13px 13px 0px 13px',
								borderBottom: '1px solid lightgray',
							}}
						>
							<Typography
								variant="h6"
								sx={{
									fontFamily: 'Poppins',
									fontSize: '17px',
									fontWeight: '500',
								}}
							>
								Responses
							</Typography>
						</Grid>
						<Grid
							item
							xs={12}
							lg={12}
							md={12}
							sm={12}
							xl={12}
							// sx={{ padding: '7px 15px' }}
						>
							<FormControlLabel
								value="end"
								control={<Checkbox />}
								label={
									<Typography
										variant="body1"
										style={{
											fontFamily: 'Poppins',
											fontSize: '16px',
											fontWeight: '400',
											color: 'black',
										}}
									>
										Instant Reply
									</Typography>
								}
								labelPlacement="end"
							/>
						</Grid>
						<Grid
							item
							xs={12}
							lg={12}
							md={12}
							sm={12}
							xl={12}
							sx={{ background: '#F9F9F9' }}
						>
							<FormControlLabel
								value="end"
								control={<Checkbox />}
								label={
									<Typography
										variant="body1"
										style={{
											fontFamily: 'Poppins',
											fontSize: '16px',
											fontWeight: '400',
											color: 'black',
										}}
									>
										Away Messagge
									</Typography>
								}
								labelPlacement="end"
							/>
						</Grid>
						<Grid
							item
							xs={12}
							lg={12}
							md={12}
							sm={12}
							xl={12}
							// sx={{ padding: '7px 15px' }} 
						>
							<FormControlLabel
								value="start"
								control={<Checkbox />}
								label={
									<Typography
										variant="body1"
										style={{
											fontFamily: 'Poppins',
											fontSize: '16px',
											fontWeight: '400',
											color: 'black',
										}}
									>
										Contact Info
									</Typography>
								}
								labelPlacement="end"
							/>
						</Grid>
						<Grid
							item
							xs={12}
							lg={12}
							md={12}
							sm={12}
							xl={12}
							sx={{ background: '#F9F9F9' }}
						>
							<FormControlLabel
								value="start"
								control={<Checkbox />}
								label={
									<Typography
										variant="body1"
										style={{
											fontFamily: 'Poppins',
											fontSize: '16px',
											fontWeight: '400',
											color: 'black',
										}}
									>
										Location
									</Typography>
								}
								labelPlacement="end"
							/>
						</Grid>
						<Grid
							item
							xs={12}
							lg={12}
							md={12}
							sm={12}
							xl={12}
							// sx={{ padding: '12px 15px', }}
						>
							<Typography
								variant="body1"
								sx={{
									fontFamily: 'Poppins',
									fontSize: '16px',
									fontWeight: '400',
									color: 'black',
								}}
							>
								Genetrate Auto Suggesstion
							</Typography>
						</Grid>
						<Grid
							item
							xs={12}
							lg={12}
							md={12}
							sm={12}
							xl={12}
							sx={{ background: '#F9F9F9' }}
						>
							<Typography
								variant="body1"
								sx={{
									fontFamily: 'Poppins',
									fontSize: '16px',
									fontWeight: '400',
									color: 'black',
								}}
							>
								All Contacts
							</Typography>
						</Grid>
						<Grid
							item
							xs={12}
							lg={12}
							md={12}
							sm={12}
							xl={12}
							// sx={{ padding: '12px 15px', }}
						>
							<Typography
								variant="body1"
								sx={{
									fontFamily: 'Poppins',
									fontSize: '16px',
									fontWeight: '400',
									color: 'black',
								}}
							>
								FAQs
							</Typography>
						</Grid>
					</Grid>
					<Grid item container lg={7.5} xl={7.5} md={7.5} sm={7.5}>
						<Grid
							item
							xs={12}
							lg={12}
							md={12}
							sm={12}
							xl={12}
							sx={{
								background: '#EEF5FFCC',
								padding: ' 13px 13px 13px 13px',
								borderBottom: '1px solid lightgray',
								borderLeft: '1px solid lightgray',
						   display:'flex',
						   justifyContent:'space-between',
						   alignItems:'center',
							}}
						>
							<Typography
								variant="h6"
								sx={{
									fontFamily: 'Poppins',
									fontSize: '17px',
									fontWeight: '500',
								}}
							>
								Add Auto Suggesstion
							</Typography>
						 <Button variant='outlined' startIcon={<AddIcon />} >
						   Add More
						 </Button>
						</Grid>
						<Box maxHeight="475px" overflow="auto">
							<Grid container>
								{suggestions.map((suggestion, index) => (
									<Grid
										key={index}
										item
										xs={12}
										lg={12}
										md={12}
										sm={12}
										xl={12}
										sx={{ padding: ' 13px', borderLeft: '1px solid lightgray' }}
									>
										<Typography
											variant="body1"
											sx={{
												fontFamily: 'Poppins',
												fontSize: '14px',
												fontWeight: '500',
											}}
										>
											{suggestion.label}
										</Typography>
										<Paper sx={{ display: 'flex', alignItems: 'center' }}>
											<Paper
												component="form"
												sx={{
													display: 'flex',
													alignItems: 'center',
													width: '100%',
													border: '1px solid #00000026',
													boxShadow: ' 0px 1px 10px 0px #79ACF178 inset',
													borderRadius: '4px',
												}}
											>
												<InputBase
													sx={{ ml: 1, flex: 1 }}
													defaultValue={suggestion.value}
													onChange={(e) =>
														handleChangeDefaultValue(index, e.target.value)
													}
												/>
												<IconButton
													type="button"
													color="primary"
													sx={{
														p: '10px',
														border: '1px solid #00000026',
														borderRadius: '2px',
													}}
													aria-label="search"
												>
													<AddIcon />
												</IconButton>
												<IconButton
													color="primary"
													fontSize="large"
													sx={{
														p: '10px',
														border: '1px solid #00000026',
														borderRadius: '2px',
													}}
												>
													<RemoveIcon />
												</IconButton>
											</Paper>
											<IconButton sx={{ p: '10px' }}>
												<MenuIcon />
											</IconButton>
										</Paper>
									</Grid>
								))}
							</Grid>
						</Box>
					</Grid>
			</Grid>
		</ThemeProvider>
	);
}

export default MessagesSetting;
